import React from 'react'

export const UserName = ({ children }) => {
    return <span className="user-name">{children}</span>
}